module.exports = __webpack_public_path__ + "static/img/male-3.9e1700c7.png";